export default __webpack_public_path__ + "static/media/Group 3193@2x.bf4d158b.png";